import { render, staticRenderFns } from "./TaxableIncomeKPM.vue?vue&type=template&id=f1719b94"
import script from "./TaxableIncomeKPM.vue?vue&type=script&lang=js"
export * from "./TaxableIncomeKPM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports